import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import SectionWrapper from '../../shared/SectionWrapper';
import {
  SectionTitle,
  SectionPrompt,
  EducationCard,
  EducationDegree,
  EducationInstitution,
  EducationPeriod,
} from '../styles';

interface EducationProps {
  themeName: ThemeType;
}

interface EducationData {
  degree: string;
  institution: string;
  period: string;
}

const Education: React.FC<EducationProps> = ({ themeName }) => {
  const { t } = useTranslation();
  const items = t('ClassicPage.education.items', { returnObjects: true }) as EducationData[];

  if (!Array.isArray(items)) return null;

  return (
    <SectionWrapper id="education" themeName={themeName}>
      <SectionPrompt $themeName={themeName}>$ cat education.log</SectionPrompt>
      <SectionTitle $themeName={themeName}>{t('ClassicPage.education.title')}</SectionTitle>
      {items.map((edu, i) => (
        <EducationCard key={i} $themeName={themeName}>
          <EducationDegree $themeName={themeName}>{edu.degree}</EducationDegree>
          <EducationInstitution $themeName={themeName}>{edu.institution}</EducationInstitution>
          {edu.period && <EducationPeriod $themeName={themeName}>{edu.period}</EducationPeriod>}
        </EducationCard>
      ))}
    </SectionWrapper>
  );
};

export default Education;
